import { Brand } from '@blade/std-lib'

export const PremiumPurchaseIdTypeId = 'tradebot-tma/PremiumPurchaseId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PremiumPurchaseIdTypeId = typeof PremiumPurchaseIdTypeId

export type PremiumPurchaseId = Brand.Branded<string, PremiumPurchaseIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PremiumPurchaseId = Brand.nominal<PremiumPurchaseId>()
